import React from 'react';
import ProfileImage from '../../profileImage';

const TeamHeader = ({ selectedChild, teamData, stats }) => {
  return (
    <div className="rounded-2xl shadow-xl overflow-hidden mb-8" style={{background: 'linear-gradient(135deg, #e25820 0%, #d14d1a 100%)'}}>
      <div className="p-8 text-white">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between">
          <div className="flex items-center space-x-6 mb-6 md:mb-0">
            <div className="relative">
              <ProfileImage
                image={selectedChild?.profilePicture}
                alt={selectedChild?.userName}
                className="w-20 h-20 rounded-full object-cover border-4 border-white/20"
              />
              <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-green-500 border-3 border-white rounded-full"></div>
            </div>
            
            {/* Team Logo */}
            {teamData?.logo && (
              <div className="relative">
                <img
                  src={teamData.logo}
                  alt={teamData.name}
                  className="w-20 h-20 rounded-xl object-cover border-4 border-white/20"
                />
              </div>
            )}
            
            <div className="flex-1">
              <h1 className="text-4xl font-bold mb-2">
                {teamData?.name || 'Team Overview'}
              </h1>
              <p className="text-orange-100 text-lg mb-1">
                {selectedChild?.userName}'s Team
              </p>
              <div className="flex items-center space-x-4 text-orange-200 text-sm">
                <span>{teamData?.organization?.name || teamData?.league}</span>
                <span>•</span>
                <span>{teamData?.sport}</span>
                <span>•</span>
                <span>{teamData?.type}</span>
              </div>
              
              {/* Organization Info */}
              {teamData?.organization && (
                <div className="flex items-center space-x-3 mt-3">
                  {teamData.organization.logo && (
                    <img
                      src={teamData.organization.logo}
                      alt={teamData.organization.name}
                      className="w-12 h-12 rounded-lg object-cover border-2 border-white/20"
                    />
                  )}
                  <div>
                    <p className="text-orange-100 text-sm font-medium">
                      {teamData.organization.name}
                    </p>
                    <p className="text-orange-200 text-xs">Organization</p>
                  </div>
                </div>
              )}
            </div>
          </div>
          
          {/* Quick Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="text-center">
              <div className="text-2xl font-bold">{stats.totalPlayers}</div>
              <div className="text-orange-200 text-sm">Players</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold">{stats.totalSupervisors}</div>
              <div className="text-orange-200 text-sm">Staff</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold">{teamData?.totalMembers || 0}</div>
              <div className="text-orange-200 text-sm">Total</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamHeader; 